/** @flow */
import * as React from 'react';
import has from 'lodash/has';

/**
 * Generates object with props to show error message,
 * and error state in MUI fields.
 *
 * @param {String} name of the field
 * @param {Object} touched Touched fields
 * @param {Object} errors Errors in fields
 */
const errorProps = (name, touched, errors) => ({
  helperText:
    has(touched, name) && has(errors, name) ? (
      <span>{errors[name]}</span>
    ) : null,

  error: has(touched, name) && has(errors, name),
});

export default errorProps;



// WEBPACK FOOTER //
// ./src/components/ContactForm/errorProps.js